import {useRouter} from 'next/router';
import type {FC} from 'react';
import {RECRUITING_INFO} from '../../../../config/constants/routes';
import {useGetCalendar} from '../../../../core/repositories/calendarRepository';
import {useAuth} from '../../../../core/usecases/auth/AuthContext';
import {useIsAppWebView} from '../../../../shared/hooks/useIsAppWebView';
import {RightSideCalendarPresentation} from './presentation';

type Props = {
  className?: string;
};

export const RightSideCalendarContainer: FC<Props> = ({className}) => {
  const isWebView = useIsAppWebView();
  const {user} = useAuth();
  const {data} = useGetCalendar({});
  const router = useRouter();

  const handleAddSchedule = () => {
    if (isWebView) {
      window.location.href = RECRUITING_INFO;
    } else {
      void router.push(RECRUITING_INFO);
    }
  };

  return (
    <RightSideCalendarPresentation
      userName={user?.familyName}
      calendarData={data?.ok ? data.value : undefined}
      isError={!data?.ok}
      onAddSchedule={handleAddSchedule}
      className={className}
    />
  );
};
